module.exports = __webpack_public_path__ + "static/media/42_tn.e1ce4253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/42_tn.jpg
// module id = 255
// module chunks = 0